import { Card as CardType, QuestionTypes } from "../types";

interface QuestionCard extends CardType {
  activity: QuestionTypes | "other";
}

export const QUESTION_CARDS: QuestionCard[] = [
  {
    genre: "question",
    description:
      "What is the most common birthday in the world? (Answer: September 9th)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common name in the world? (Answer: Muhammad)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common password in the world? (Answer: 123456)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description: "What is the most common dream people have? (Answer: Falling)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common lie people tell? (Answer: 'I'm fine')",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common food allergy in the world? (Answer: Milk)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common color in national flags? (Answer: Red)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description: "What is the most common pet in the world? (Answer: Fish)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common phobia in the world? (Answer: Arachnophobia - fear of spiders)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the only letter that doesn't appear in any US state name? (Answer: Q)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common blood type in the world? (Answer: O positive)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common eye color in the world? (Answer: Brown)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common day of the week for weddings? (Answer: Saturday)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },

  {
    genre: "question",
    description:
      "What percentage of people have had a threesome? (Answer: Around 20%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met on a dating app? (Answer: Around 40%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex in a car? (Answer: Around 60%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with a friend? (Answer: Around 45%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they worked with? (Answer: Around 35%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a party? (Answer: Around 55%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met on vacation? (Answer: Around 30%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a bar? (Answer: Around 50%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a club? (Answer: Around 40%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a concert? (Answer: Around 25%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a sports event? (Answer: Around 20%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a wedding? (Answer: Around 15%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a funeral? (Answer: Around 5%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had sex with someone they met at a religious event? (Answer: Around 10%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have lied about their age on social media? (Answer: Around 45%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be sick to get out of work? (Answer: Around 65%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have snooped through someone's phone? (Answer: Around 35%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be on the phone to avoid talking to someone? (Answer: Around 75%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to laugh at a joke they didn't understand? (Answer: Around 80%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be busy to avoid hanging out? (Answer: Around 70%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be asleep to avoid conversation? (Answer: Around 60%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to like a gift they hated? (Answer: Around 85%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be working when they were actually on social media? (Answer: Around 55%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be busy to avoid answering texts? (Answer: Around 65%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be happy when they were actually sad? (Answer: Around 75%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be confident when they were nervous? (Answer: Around 70%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be interested in a conversation they hated? (Answer: Around 80%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be working out when they were actually just taking selfies? (Answer: Around 40%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have pretended to be busy to avoid cleaning their house? (Answer: Around 60%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },

  {
    genre: "question",
    description:
      "Answer this: 'What's the capital of Australia?' (Answer: Canberra)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the legal drinking age in the majority of Europe? (Answer: 18)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description: "How many condoms come in a standard box? (Answer: 12)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people admit to fantasizing about their friends? (Answer: ~60%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most sensitive part of the human body? (Answer: Lips)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average duration of sex globally? (Answer: ~5.4 minutes)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the most common fantasy people have? (Answer: Threesome)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "How many calories does the average person burn during sex? (Answer: ~100)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the most common day for people to have sex? (Answer: Saturday)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "In what country is public nudity most widely accepted? (Answer: Germany)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people admit to faking it in bed? (Answer: ~60%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the most searched category on adult sites worldwide? (Answer: Lesbian)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "How long does the average first kiss last? (Answer: ~12 seconds)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the largest erogenous zone in the body? (Answer: The skin)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average length of an erect penis? (Answer: Around 5.16 inches / 13.12 cm)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which organ in the human body is primarily responsible for sexual pleasure? (Answer: The brain)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the scientific term for the female G-spot? (Answer: Gräfenberg Spot)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country is known for having the highest frequency of sex according to surveys? (Answer: Greece)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "How long does the average male orgasm last? (Answer: Around 6 seconds)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "How long does the average female orgasm last? (Answer: Around 20 seconds)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the record for the most female orgasms in one hour? (Answer: 134)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description: "What is the most common sexual fantasy? (Answer: Threesome)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which sexually transmitted infection (STI) is the most common worldwide? (Answer: Human Papillomavirus (HPV))",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the scientific term for the fear of sex? (Answer: Genophobia)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which fruit is said to be an aphrodisiac due to its shape and texture? (Answer: Fig)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which part of the body has the most nerve endings? (Answer: The clitoris, with around 8,000 nerve endings)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people admit to having had a one-night stand? (Answer: Around 55-65%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the world record for the most sexual partners in 24 hours? (Answer: 919 by Lisa Sparxxx in 2004)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which animal has the longest penis relative to body size? (Answer: Barnacle)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which sex position is considered the most popular worldwide? (Answer: Missionary)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average amount of time sex lasts for couples? (Answer: Between 5-7 minutes)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "How many calories does the average sex session burn? (Answer: Around 100-200 calories)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which male body part continues to grow even after death? (Answer: The penis appears larger due to blood pooling, but it does not actually grow)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of women have faked an orgasm? (Answer: Around 50-70%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the most common cause of erectile dysfunction? (Answer: Stress and anxiety)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which sex act is illegal in more than 10 U.S. states? (Answer: Oral sex, though rarely enforced)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the name of the hormone responsible for sexual arousal? (Answer: Dopamine and oxytocin)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average number of times a couple has sex per year? (Answer: Around 50-60 times)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country produces the most adult films? (Answer: United States)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of men reach orgasm every time they have sex? (Answer: Around 75%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of women reach orgasm every time they have sex? (Answer: Around 30-40%)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which food contains natural compounds that may increase libido? (Answer: Dark chocolate)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have admitted to joining the 'mile-high club'? (Answer: Around 4-5%)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average number of sexual partners a person has in their lifetime? (Answer: Around 7-10 partners)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which muscle is primarily engaged during orgasm? (Answer: Pubococcygeus muscle)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the technical term for swallowing semen? (Answer: Semen ingestion)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country was the first to legalize same-sex marriage? (Answer: Netherlands, in 2001)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people admit to watching porn regularly? (Answer: Around 70%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the world record for longest recorded orgasm? (Answer: 43 seconds)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which animal has the largest penis relative to its body? (Answer: Barnacle)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the rarest human blood type, which can sometimes affect fertility? (Answer: AB negative)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the official term for a fetish involving armpits? (Answer: Maschalagnia)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which fruit is said to resemble the male testicles, leading to its name? (Answer: Avocado)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of couples have admitted to using sex toys? (Answer: Over 50%)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which famous historical figure was said to have consumed oysters daily for their aphrodisiac effects? (Answer: Casanova)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the average speed of ejaculation? (Answer: Around 28 mph / 45 km/h)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the highest average age of losing virginity? (Answer: India, around 19.8 years old)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the name of the hormone that increases after orgasm, making people feel closer? (Answer: Oxytocin)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which part of the body becomes darker due to increased blood flow during arousal? (Answer: Nipples)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What is the term for someone who is only sexually attracted to intelligence? (Answer: Sapiosexual)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which historical civilization used crocodile dung as an early form of birth control? (Answer: Ancient Egyptians)",
    penaltyCost: 1,
    activity: "eggheads",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which body part is scientifically proven to be more sensitive in women than in men? (Answer: Lips)",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which famous book, published in 1969, is known as the 'Sex Bible'? (Answer: The Joy of Sex)",
    penaltyCost: 1,
    activity: "chase",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have admitted to having sex in a public place? (Answer: Around 25-30%)",
    penaltyCost: 1,
    activity: "pointless",
    pub: true,
  },

  {
    genre: "question",
    description:
      "What percentage of people fantasize about their partner's friends? A) 20% B) 40% C) 60% D) 80% (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What's the most common sex dream? A) Ex-partners B) Celebrities C) Coworkers D) Strangers (Answer: B)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the longest average foreplay? A) Brazil B) France C) Netherlands D) Canada (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have used food during intimate moments? A) 15% B) 28% C) 42% D) 55% (Answer: B)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which of these is NOT a real dating app? A) Coffee Meets Bagel B) Hinge C) Butterflies D) Bumble (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of couples use role-play? A) 10% B) 22% C) 35% D) 48% (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have had a one-night stand? A) 15% B) 35% C) 55% D) 75% (Answer: B)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country reports the highest sexual satisfaction? A) Switzerland B) Spain C) Italy D) Greece (Answer: A)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "What percentage of people have sexted? A) 25% B) 40% C) 55% D) 70% (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which profession is most likely to be fantasized about? A) Doctor B) Teacher C) Chef D) Firefighter (Answer: A)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the highest rate of BDSM interest? A) USA B) Germany C) Netherlands D) UK (Answer: B)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country reports the most sex toy purchases per capita? A) Denmark B) Sweden C) Japan D) France (Answer: A)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the highest percentage of people into role-play? A) Brazil B) Spain C) Italy D) France (Answer: D)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country searches for 'fetish' most online? A) USA B) Australia C) Canada D) UK (Answer: B)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the highest percentage of people who identify as kinky? A) Germany B) Netherlands C) Denmark D) Sweden (Answer: C)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
  {
    genre: "question",
    description:
      "Which country has the most fetish clubs per capita? A) Germany B) Japan C) USA D) UK (Answer: A)",
    penaltyCost: 1,
    activity: "hwtbam",
    pub: true,
  },
];
